export default __webpack_public_path__ + "static/media/product-banner1.8f256e94.png";